import { render } from "./CheckListTab.vue?vue&type=template&id=ab1c3124"
import script from "./CheckListTab.vue?vue&type=script&lang=js"
export * from "./CheckListTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__